// extracted by mini-css-extract-plugin
export default {"adWizard":"AdWizard_adWizard__f3OsQ"};